import axios from 'axios';
import { CySku } from 'types';

export const fetchCySkus = (brandId: number) =>
  axios.get<CySku[]>(`/api/brands/${brandId}/cy_skus`);
